"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _map = _interopRequireDefault(require("lodash/map"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _history = require("history");

var _ecommerceEventHelper = require("@eig-builder/core-utils/analytics/helpers/ecommerce-event-helper");

var _reactRouterDom = require("react-router-dom");

var _privateRoute = _interopRequireDefault(require("../containers/private-route"));

var _constants = require("./../reducers/constants");

var _BootstrapperContext = _interopRequireDefault(require("./../contexts/BootstrapperContext"));

var _analyticEvents = require("@eig-builder/core-utils/analytics/middleware/analytic-events");

var BaseRouter =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(BaseRouter, _PureComponent);

  function BaseRouter(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BaseRouter);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BaseRouter).call(this, props));

    _this.mapTheRoutes = function (routes) {
      return (0, _map["default"])(routes, function (route, index) {
        // Make sure that the analytics tags are set, otherwise throw an error
        if (!process.env.isProd) {
          if ((0, _isEmpty["default"])(route.pageType) || (0, _isEmpty["default"])(route.flowType) && !(0, _isFunction["default"])(route.flowType)) {
            console.error('!!! MUST FIX !!! is missing flowType of pageType, we need this for analaytics\n!!! MUST FIX !!! we need this because we have more then 1 onboarding flow now\n!!! MUST FIX !!! find help here: https://confluence.endurance.com/display/EWB/Analytics+Tracking', route.path || route.pattern);
          }
        }

        if (route.isPublic) {
          return _react["default"].createElement(_reactRouterDom.Route, {
            key: index,
            path: route.path || route.pattern,
            component: route.component,
            exactly: route.exactly
          });
        }

        return _react["default"].createElement(_privateRoute["default"], (0, _extends2["default"])({
          key: index,
          path: route.path || route.pattern,
          component: route.component,
          exactly: route.exactly,
          loginUrl: _this.props.loginUrl
        }, route));
      });
    };

    _this.history = (0, _history.createBrowserHistory)(props);
    _this.trackPageAnalytics = _this.trackPageAnalytics.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BaseRouter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _analyticEvents.addTrackAnalyticsListener)(this.trackPageAnalytics);
      this.history.listen(function (location, direction) {
        _this2.context.store.dispatch({
          type: _constants.LOCATION_CHANGE,
          payload: location
        });

        if (_this2.context.analyticsService && _this2.context.analyticsService.trackPageView) {
          _this2.context.analyticsService.trackPageView(location.pathname);
        }

        (0, _ecommerceEventHelper.TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId)(location.search, _this2.context.analyticsService);

        if (direction !== 'REPLACE') {
          window.scrollTo(0, 0);
        }

        if (direction === 'POP') {
          _this2.forceUpdate();
        }
      });
      this.context.store.dispatch({
        type: _constants.LOCATION_CHANGE,
        payload: window.location
      });
      (0, _ecommerceEventHelper.TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId)(window.location.href, this.context.analyticsService);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _analyticEvents.removeAddTrackAnalyticsListener)(this.trackPageAnalytics);
    }
  }, {
    key: "trackPageAnalytics",
    value: function trackPageAnalytics() {
      var analyticsService = this.context.analyticsService;
      analyticsService.trackPageView(window.location.pathname);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var routes = (0, _flatten["default"])(this.props.routes.map(function (route) {
        if (typeof route === 'function') {
          return route();
        } else {
          return route;
        }
      }));
      var AppWrapper = this.props.appWrapper;
      return _react["default"].createElement(_reactRouterDom.Router, {
        history: this.history
      }, _react["default"].createElement(AppWrapper, null, _react["default"].createElement(_reactRouterDom.Switch, null, this.mapTheRoutes(routes), _react["default"].createElement(_reactRouterDom.Route, {
        render: function render() {
          var path = "".concat(_this3.props.defaultRoute).concat(window.location.search).concat(window.location.hash);
          return _react["default"].createElement(_reactRouterDom.Redirect, {
            to: path
          });
        }
      }))));
    }
  }]);
  return BaseRouter;
}(_react.PureComponent);

BaseRouter.contextType = _BootstrapperContext["default"];
BaseRouter.propTypes = {
  defaultRoute: _propTypes["default"].string.isRequired,
  routes: _propTypes["default"].array.isRequired,
  loginUrl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  appWrapper: _propTypes["default"].any
};
BaseRouter.defaultProps = {
  appWrapper: _react["default"].Fragment
};
var _default = BaseRouter;
exports["default"] = _default;